import { create } from 'zustand'

interface UIState {
    sidebarOpen: boolean
    sidebarCollapsed: boolean
    currentPageTitle: string
    globalLoading: boolean

    toggleSidebar: () => void
    setSidebarOpen: (open: boolean) => void
    setSidebarCollapsed: (collapsed: boolean) => void
    setPageTitle: (title: string) => void
    setGlobalLoading: (loading: boolean) => void
}

export const useUIStore = create<UIState>((set) => ({
    sidebarOpen: false,
    sidebarCollapsed: false,
    currentPageTitle: 'Dashboard',
    globalLoading: false,

    toggleSidebar: () =>
        set((state) => ({ sidebarOpen: !state.sidebarOpen })),

    setSidebarOpen: (open) => set({ sidebarOpen: open }),

    setSidebarCollapsed: (collapsed) =>
        set({ sidebarCollapsed: collapsed }),

    setPageTitle: (title) => set({ currentPageTitle: title }),

    setGlobalLoading: (loading) => set({ globalLoading: loading }),
}))
